module.exports = __webpack_public_path__ + "static/media/systemConfig_default.665f398b.svg";